import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ReleaseOrderService {
    constructor(private http: HttpClient) {}

    getReleaseOrderList(filter: any) {
        return this.http.post('api:///ReleaseOrder/GetReleaseOrderList', filter);
    }

    getReleaseOrderItems(filter: any) {
        return this.http.post('api:///ReleaseOrder/GetReleaseOrderItems', filter);
    }

    getReleaseOrder(releaseOrderId: number): Observable<any> {
        return this.http.get(`api:///ReleaseOrder/GetReleaseOrder/${releaseOrderId}`);
    }

    getReleaseOrderReport(releaseOrderId: number): Observable<any> {
        return this.http.get(`api:///ReleaseOrder/GetReleaseOrderReport/${releaseOrderId}`);
    }

    getReleaseOrderChanges(releaseOrderId: number): Observable<any> {
        return this.http.get(`api:///ReleaseOrder/GetReleaseOrderChanges/${releaseOrderId}`);
    }

    getLinesForReleaseOrder(): Observable<any> {
        return this.http.get<any>(`api:///ReleaseOrder/GetLinesForReleaseOrder`);
    }

    getTerminalsOnReleaseOrder(): Observable<any> {
        return this.http.get<any>(`api:///ReleaseOrder/GetTerminalsOnReleaseOrder`);
    }

    getCreateServiceRequestContextForReleaseOrder(body: any): Observable<any> {
        return this.http.post<any>(`api:///ReleaseOrder/GetCreateServiceRequestContextForReleaseOrder`, body);
    }

    createReleaseOrder(body: any): Observable<any> {
        return this.http.post<any>(`api:///ReleaseOrder/CreateReleaseOrder/`, body);
    }

    editReleaseOrder(body: any): Observable<any> {
        return this.http.post<any>(`api:///ReleaseOrder/EditReleaseOrder/`, body);
    }

    addContainersFromBulPCS(body: any): Observable<any> {
        return this.http.post<any>(`api:///ReleaseOrder/AddContainersFromBulPCS/`, body);
    }

    addEmptyContainersToReleaseOrder(body: any): Observable<any> {
        return this.http.post<any>(`api:///ReleaseOrder/AddEmptyContainersToReleaseOrder/`, body);
    }

    releaseReleaseOrder(releaseOrderId: number) {
        return this.http.post('api:///ReleaseOrder/ReleaseReleaseOrder', { id: releaseOrderId });
    }

    deleteReleaseOrder(releaseOrderId: number) {
        return this.http.post('api:///ReleaseOrder/DeleteReleaseOrder', { id: releaseOrderId });
    }

    cancelReleaseOrder(body: any) {
        return this.http.post('api:///ReleaseOrder/CancelReleaseOrder', body);
    }

    removeContainers(body: any) {
        return this.http.post('api:///ReleaseOrder/RemoveContainersFromReleaseOder', body);
    }

    cancelContainers(body: any) {
        return this.http.post('api:///ReleaseOrder/CancelContainersFromReleaseOder', body);
    }

    getAllItemIds(releaseOrderId: number): Observable<any> {
        return this.http.get<any>(`api:///ReleaseOrder/GetAllItemIds/${releaseOrderId}`);
    }

    getNextReleaseOrderNumber(filter: any): Observable<any> {
        return this.http.post<any>(`api:///ReleaseOrder/GetNextReleaseOrderNumber`, filter);
    }
}
